export default "__VITE_ASSET__1ML1hcr4__"